import DashboardLayout from "../layout/DashboardLayout.vue";
import PagError from "../layout/PagError.vue";
// GeneralViews
import NotFound from "../pages/NotFoundPage.vue";

import Vue from "vue";
import Router from "vue-router";
import store from "../vuex/store.js";
import Cookies from "js-cookie";

//AUTH
import Start from "src/pages/Auth/Start.vue";
import Return from "src/pages/Auth/Return.vue";

Vue.use(Router);

const routes = [
  {
    path: "/",
    component: PagError,
  },
  {
    path: "/return",
    component: Return,
  },
  {
    path: "/inicio/:token",
    component: Start,
    children: [
      {
        path: "/inicio/:token",
        name: "start",
        component: Start,
      },
    ],
  },

  //   ]
  // },
  { path: "*", component: NotFound },
  { path: "", component: PagError },
];
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   console.log('accediendo')
//   const accessToken = Cookies.get("access_token");

//   if (accessToken) {
//     if (to.matched.some(record => record.meta.requiresAuth) && !store.state.status && !accessToken) {
//       alert('Please, sign in to continue')
//       next("/schedules");
//     } else if (store.state.status && accessToken) {
//       console.log('logged')
//       next("/schedules/:token")
//     } else {
//       console.log('Next')
//       next()
//     }
//   } else {
//     console.log('TOKEN NOT FOUND');
//     console.log(to.name)
//     console.log(from.name)
//     if (to.name != 'schedules') {
//       next("/schedules");
//     } else {
//       next();
//     }

//   }

// })
/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default router;
